export default defineAppConfig({
  icon: {
    cssLayer: 'icon',
    mode: 'css'
  },
  ui: {
    colors: {
      primary: 'dark-green',
      secondary: 'pink',
      success: 'green',
      info: 'blue',
      warning: 'yellow',
      danger: 'red',
      neutral: 'gray',
      bg: 'beige'
    },
    // Using the `tw` function is fine for development but breaks production builds.
    // So be sure to remove them before pushing :)
    blogPosts: {
      base: 'flex flex-col gap-8 lg:gap-y-8',
      variants: {
        orientation: {
          horizontal: 'sm:grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
          vertical: ''
        }
      }
    }
  }
})
